<template>
    <div v-if="isLoading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
        <v-container>
            <v-form>
                <v-row>
                    <h2 class="pb-5">
                        {{ this.pageTitle }}
                        <span class="page_title_value">{{ this.pageTitleValue }}</span>
                    </h2>
                </v-row>
                <v-row class="mb-4">
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-btn color="warning" v-on:click="goBack">{{$t('button.back')}}</v-btn>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmrewardsimulation.rewardrecorddesc')" type="text" v-model="formData.simulationdesc" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmrewardsimulation.rewardrecordcode')" type="text" v-model="formData.simulationcode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentdesc')" type="text" v-model="formData.pmassessmentrecorddesc" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcode')" type="text" v-model="formData.pmassessmentrecordcode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmmoderation.periodfromdate')" type="text" v-model="formData.pmassestartdate" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmmoderation.perioduntildate')" type="text" v-model="formData.pmasseenddate" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                      <v-spacer></v-spacer>
                    </v-col>
                    <v-col cols="3" sm="3" class="pb-n4 mt-n8">
                        <v-btn color="primary" v-on:click="recreateHandler">{{$t('pmrewardsimulation.overwriteexsitresult')}}</v-btn>
                    </v-col>
                </v-row>
                <v-card class="pa-4 elevation-4 mb-6" v-if="showTargetCard">
                    <v-row justify="space-between" align="center">
                        <v-col cols="10">
                            <h2 class="blue--text">{{$t('pmrewardsimulation.targetdetails')}}</h2>
                        </v-col>
                        <v-col cols="2" class="text-right">
                            <v-btn icon @click="showTargetCard = false">
                            <v-icon>mdi-chevron-up</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="4">
                            <v-text-field
                            outlined
                            :label="$t('pmrewardsimulation.targetincrementamt')"
                            type="number"
                            :rules="[rules.required]"
                            dense
                            v-model="formData.targetincrementamt"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="4" sm="4">
                            <v-text-field
                            outlined
                            :label="$t('pmrewardsimulation.targetbonusamt')"
                            :rules="[rules.required]"
                            type="number"
                            dense
                            v-model="formData.targetbonusamt"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="3" sm="3">
                            <v-btn color="primary" @click="amountSimulateHandler" style="padding: 0 50px;">
                            {{$t('pmrewardsimulation.simulate')}}
                            </v-btn>
                        </v-col>
                        <v-col cols="1" sm="1">
                            <v-spacer></v-spacer>
                        </v-col>
                        <v-col cols="3" sm="3">
                            <v-btn color="primary" @click="applyToFinalIncrementHandler">
                                {{$t('pmrewardsimulation.applytargetincre')}}
                            </v-btn>
                        </v-col>
                        <v-col cols="1" sm="1">
                            <v-spacer></v-spacer>
                        </v-col>
                        <v-col cols="3" sm="3">
                            <v-btn color="primary" @click="applyToFinalBonusHandler">
                                {{$t('pmrewardsimulation.applytargetbonus')}}
                            </v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" class="text-body-2" style="color: #757575; font-style: italic;">
                            {{$t('pmrewardsimulation.disclaimer')}}
                        </v-col>
                    </v-row>
                </v-card>

                <!-- Collapsed Toggle Button -->
                <v-btn
                    v-else
                    icon
                    class="mb-3"
                    @click="showTargetCard = true"
                >
                    <v-icon>mdi-chevron-down</v-icon>
                </v-btn>

            </v-form>
            
            <v-row>
                <v-col cols="2" v-for="(card, index) in cards" :key="index">
                    <v-card
                    class="pa-4 d-flex flex-column justify-space-between"
                    height="150"
                    elevation="4"
                    :style="{
                        backgroundColor: index < 3 ? '#760707' : '#0d8427',
                        borderRadius: '20px',
                        color: 'white'
                    }"
                    >
                    <!-- Currency Code -->
                    <div class="text-caption font-weight-medium">
                        {{ currencycode }}
                    </div>

                    <!-- Amount -->
                    <div class="text-h6 font-weight-bold">
                        {{ formatAmount(card.amount) }}
                    </div>

                    <!-- Label -->
                    <div class="text-caption" style="white-space: pre-line;">
                        {{ card.label }}
                    </div>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <app-table
                        :key="detailkey"
                        v-bind:parentObject="{
                            tabHeader: tabHeader,
                            detailItem: this.pmRewardSimulationDetailList,
                            pageTitle: this.pageTitle + this.pageTitleValue,
                        }"
                        @updateCard="detailRowUpdateHandler"
                    />
                </v-col>
            </v-row>

            <div v-if="isConfirm">
                <app-confirm
                    v-bind:parentObject="{
                    messageConfirm: this.messageConfirm,
                    isConfirm: this.isConfirm,
                    }"
                    v-on:confirm="handleConfirm(true)"
                    v-on:cancelConfirm="handleConfirm(false)"
                />
            </div>
        </v-container>
    </div>
</template>

<script>
import moment from 'moment';
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import CRUDTable from "./CRUDTable";


export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-confirm": ConfirmDialog,
        "app-table": CRUDTable,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                id: null, 
                rewardrecordid: this.$route.params.rewardid,
                pmassessmentrecordid:this.$route.params.assessmentid,
                targetbonusamt: null,
                targetincrementamt: null,
                stamp: null,
                updatedby: this.$store.getters.userId,
            },

            simulatedbonusamt:0,
            targetedbonusamt:0,
            finalbonusamt:0,
            simulatedincrementamt:0,
            targetedincrementamt:0,
            finalincrementamt:0,
            pageTitle: this.$t('pmrewardsimulation.pagetitle'),
            pageTitleValue: null,

            //to show in card, the currency type
            currencyid: null,
            currencycode: null,
            currencyOptionFull: [],
            currencyOptionList: [],

            errMsg: '',
            isErr: false,
            isLoading: true,
            isExsiting: false,

            //confirm dialog
            isConfirm: false,
            messageConfirm:"",
            confirmProceed: true,//default true

            //to show the simulation card
            showTargetCard: true,
            
            //this is the 6 card to show amount, update on created()
            // cards: [
            //     { amount: 0, label: "Simulated\nIncrement" },
            //     { amount: 0, label: "Targeted\nIncrement" },
            //     { amount: 0, label: "Final\nIncrement" },
            //     { amount: 0, label: "Simulated\nBonus" },
            //     { amount: 0, label: "Targeted\nBonus" },
            //     { amount: 0, label: "Final\nBonus" }
            // ],

            //CRUD parts
            pmRewardSimulationDetailList: [],
            detailkey:0, // use to force update
            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.staffid'), value: 'staffcode', width: 'auto', sortable: false},
                { text: this.$t('columns.staffname'), value: 'staffname', width: 'auto', sortable: false},
                { text: this.$t('appraisalrecord.reviewfrom'), value: 'reviewfromdate', width: 'auto', sortable: false},
                { text: this.$t('appraisalrecord.reviewuntil'), value: 'reviewuntildate', width: 'auto', sortable: false},
                { text: this.$t('pmassementrecord.finalscore'), value: 'score', width: 'auto', sortable: false},
                { text: this.$t('Setuprankmapset.rank'), value: 'rank', width: 'auto', sortable: false},
                { text: this.$t('pmassementrecord.finalrank'), value: 'finalrank', width: 'auto', sortable: false},
                { text: this.$t('pmrewardsimulation.simulatedIncrement'), value: 'simulatedincreamtWithThousandSeparator', width: 'auto', sortable: false},
                { text: this.$t('pmrewardsimulation.targetedIncrement'), value: 'targetincreamtWithThousandSeparator', width: 'auto', sortable: false},
                { text: this.$t('pmrewardsimulation.finalIncrement'), value: 'finalincreamtWithThousandSeparator', width: 'auto', sortable: false},
                { text: this.$t('pmrewardsimulation.simulatedBonus'), value: 'simulatedbonusamtWithThousandSeparator', width: 'auto', sortable: false},
                { text: this.$t('pmrewardsimulation.targetedBonus'), value: 'targetbonusamtWithThousandSeparator' ,width: 'auto', sortable: false},
                { text: this.$t('pmrewardsimulation.finalBonus'), value: 'finalbonusamtWithThousandSeparator', width: 'auto', sortable: false},
                // { text: this.$t('pmrewardsimulation.simulatedIncrement'), value: 'simulatedincreamt', width: 'auto', sortable: false},
                // { text: this.$t('pmrewardsimulation.targetedIncrement'), value: 'targetincreamt', width: 'auto', sortable: false},
                // { text: this.$t('pmrewardsimulation.finalIncrement'), value: 'finalincreamt', width: 'auto', sortable: false},
                // { text: this.$t('pmrewardsimulation.simulatedBonus'), value: 'simulatedbonusamt', width: 'auto', sortable: false},
                // { text: this.$t('pmrewardsimulation.targetedBonus'), value: 'targetbonusamt' ,width: 'auto', sortable: false},
                // { text: this.$t('pmrewardsimulation.finalBonus'), value: 'finalbonusamt', width: 'auto', sortable: false},
                { text: this.$t('columns.company'), value: 'companycode', width: 'auto', sortable: false},
                { text: this.$t('columns.branch'), value: 'branchcode', width: 'auto', sortable: false },
                { text: this.$t('columns.department'), value: 'departmentcode', width: 'auto', sortable: false },
                { text: this.$t('columns.division'), value: 'divisioncode', width: 'auto', sortable: false },
                { text: this.$t('columns.section'), value: 'sectioncode', width: 'auto', sortable: false},
                { text: this.$t('columns.unit'), value: 'unitcode', width: 'auto', sortable: false},
                { text: this.$t('columns.grade'), value: 'gradecode', width: 'auto', sortable: false}
            ],
        }
    },
    
    created() {
        this.cards = [
            { amount: 0, label: this.$t('pmrewardsimulation.card.simulatedIncrement') },
            { amount: 0, label: this.$t('pmrewardsimulation.card.targetedIncrement') },
            { amount: 0, label: this.$t('pmrewardsimulation.card.finalIncrement') },
            { amount: 0, label: this.$t('pmrewardsimulation.card.simulatedBonus') },
            { amount: 0, label: this.$t('pmrewardsimulation.card.targetedBonus') },
            { amount: 0, label: this.$t('pmrewardsimulation.card.finalBonus') }
        ];
    },

    methods: {

        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1); // Only go back if there's a history
            } else {
                this.$router.push({ name: "pmrewardsimulationlist" }); // Go to home if no history
            }
        },

        formatAmount(val) {
            // return Number(val).toFixed(2);
            // instead of just return 2 decimal place, the below one have thousand separator
            return Number(val)
                .toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },

        async loadCurrencyListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: "/currency/all" });
                this.currencyOptionFull = res.data.rec;
                this.currencyOptionList = []; // Clear the list before pushing new items

                for (let i = 0; i < res.data.rec.length; i++) {
                    this.currencyOptionList.push({
                        text: res.data.rec[i].crcydesc,
                        value: res.data.rec[i].id,
                    });
                }

                if (this.currencyid) {
                    // Manually trigger the change handler to update other column, when edit record
                    this.changeCurrencyOption(this.currencyid);
                }
                
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        changeCurrencyOption(id) {
            let item = this.currencyOptionFull.find((item) => item.id === id);
            this.currencycode = item.crcycode;
        },

        async loadPmRewardSimulationHandler() {
            this.isErr = false;
            this.errMsg = "";
            try {
                const res = await this.$store.dispatch('get', { url: "/pmrewardsimulation/" + this.formData.rewardrecordid+"/"+this.formData.pmassessmentrecordid});
                
                if (res.status === 200 && res.data.rec) {
                    this.isExsiting = true;
                    this.formData = { ...res.data.rec };
                    this.formData.pmasseenddate = moment(this.formData.pmasseenddate).format("DD-MM-YYYY");
                    this.formData.pmassestartdate= moment(this.formData.pmassestartdate).format("DD-MM-YYYY");
                    this.currencyid= res.data.rec.currencydid;
                    this.pageTitleValue= res.data.rec.simulationcode;

                    // this.cards[1].amount = this.formData.targetincrementamt
                    // this.cards[4].amount = this.formData.targetbonusamt;
                    
              
                } else {
                    this.isExsiting = false;
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async createPmRewardSimulationHandler() {
            this.isErr = false;
            this.errMsg = "";
            try {
                const res = await this.$store.dispatch('post', { 
                    url: "/pmrewardsimulation/create",
                    payload: this.formData});

                if (res.status === 201) {
                    await this.loadPmRewardSimulationHandler();//after created,now load the record again to get the form value
                    await this.createPMRewardSimulationDetailHandler();// and then created the simulation detail
                    
                } else {
                    this.isErr = true;
                    this.errMsg = "Failed to create record";
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async createPMRewardSimulationDetailHandler() {
            this.isErr = false;
            this.errMsg = "";
            try {
                const res = await this.$store.dispatch('post', { 
                    url: "/pmrewardsimulationdetail/create",
                    payload: this.formData});

                if (res.status === 201) {//After created
                    await this.loadPmRewardSimulationDetail();
                    
                } else {
                    this.isErr = true;
                    this.errMsg = "Failed to create Simulation Detail record";
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async loadPmRewardSimulationDetail() {
            try {
                this.pmRewardSimulationDetailList=[];
                const { id, rewardrecordid, pmassessmentrecordid } = this.formData;
                const getUrl = `/pmrewardsimulationdetail/${id}/${rewardrecordid}/${pmassessmentrecordid}`;
                const res = await this.$store.dispatch('get', { url: getUrl});
                this.pmRewardSimulationDetailList = res.data.rec;

                this.pmRewardSimulationDetailList.forEach(item => {
                    item.reviewfromdate = moment(item.reviewfromdate).format("DD/MM/YYYY");
                    item.reviewuntildate = moment(item.reviewuntildate).format("DD/MM/YYYY");

                    // 2 decimal place, in number
                    item.simulatedincreamt = Math.round(item.simulatedincreamt * 100) / 100;
                    item.targetincreamt = Math.round(item.targetincreamt * 100) / 100;
                    item.finalincreamt = Math.round(item.finalincreamt * 100) / 100;
                    item.simulatedbonusamt = Math.round(item.simulatedbonusamt * 100) / 100;
                    item.targetbonusamt = Math.round(item.targetbonusamt * 100) / 100;
                    item.finalbonusamt = Math.round(item.finalbonusamt * 100) / 100;

                    // Create number in thousand separated, in text
                    item.simulatedincreamtWithThousandSeparator = this.format2DecThenComma(item.simulatedincreamt);
                    item.targetincreamtWithThousandSeparator = this.format2DecThenComma(item.targetincreamt);
                    item.finalincreamtWithThousandSeparator = this.format2DecThenComma(item.finalincreamt);
                    item.simulatedbonusamtWithThousandSeparator = this.format2DecThenComma(item.simulatedbonusamt);
                    item.targetbonusamtWithThousandSeparator = this.format2DecThenComma(item.targetbonusamt);
                    item.finalbonusamtWithThousandSeparator = this.format2DecThenComma(item.finalbonusamt); 
                });
                this.detailkey++;

            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
            }
        },

        format2DecThenComma(value) {
            // Step 1: numeric rounding (stays a number)
            const rounded = Math.round(Number(value) * 100) / 100;

            // Step 2: format with 2 decimals + thousand separator (string)
            return rounded.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        
        async amountSimulateHandler() {
            this.isErr = false;
            this.errMsg = "";

            try {
                const res = await this.$store.dispatch('put', { url: "/pmrewardsimulation/edit/" + this.formData.id, 
                payload: this.formData });
                if (res.status === 200) {
                    // this.cards[1].amount = this.formData.targetincrementamt
                    // this.cards[4].amount = this.formData.targetbonusamt;          
                    try{
                        const res = await this.$store.dispatch('put', { url: "/pmrewardsimulationdetailtargetamt/edit/" + this.formData.id, 
                        payload: this.formData });
                        if (res.status === 200) {
                            await this.loadPmRewardSimulationDetail(); // reload the detail
                            this.detailkey++;
                            await this.modifyCardHandler();
                        }
                        else
                        {
                            this.isErr = true;
                            this.errMsg = "Failed to update prorated amount";
                            this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                        }
                    }
                    catch(err){
                        this.isErr = true;
                        this.errMsg = err.message || "Network Error";
                        this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                    }
                   
                } else {
                    this.isErr = true;
                    this.errMsg = "Failed to update record";
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async modifyCardHandler() {
            // Reset the totals
            this.simulatedbonusamt = 0;
            this.targetedbonusamt=0;
            this.finalbonusamt = 0;
            this.simulatedincrementamt = 0;
            this.targetedincrementamt=0;
            this.finalincrementamt = 0;

            // Loop through each item and sum the fields
            this.pmRewardSimulationDetailList.forEach(item => {
                this.simulatedbonusamt += item.simulatedbonusamt || 0;
                this.targetedbonusamt += item.targetbonusamt ||0;
                this.finalbonusamt += item.finalbonusamt || 0;
                this.simulatedincrementamt += item.simulatedincreamt || 0;
                this.targetedincrementamt += item.targetincreamt ||0;
                this.finalincrementamt += item.finalincreamt || 0;
            });

            this.cards[0].amount = this.simulatedincrementamt;
            this.cards[1].amount = this.targetedincrementamt;
            this.cards[2].amount = this.finalincrementamt;
            this.cards[3].amount = this.simulatedbonusamt;
            this.cards[4].amount = this.targetedbonusamt;
            this.cards[5].amount = this.finalbonusamt;
        },

        async recreateHandler(){

            this.messageConfirm=this.$t('pmassementrecord.overwriteconfirm');
            this.confirmProceed = await this.waitForUserConfirmation(); // ⏳ Wait for confirmation

            if (!this.confirmProceed) {
                return; // Stop execution if user cancels
            }

            this.isExsiting= false; // Set to false to create a new record
            await this.createPmRewardSimulationHandler(); // Create new record ,at the same time create detail
            await this.loadCurrencyListHandler();
            await this.modifyCardHandler();
            
        },

        waitForUserConfirmation() {
            return new Promise((resolve) => {
                this.isConfirm = true; // Show confirmation dialog

                // Attach event listeners dynamically
                this.handleConfirm = (confirmed) => {
                    this.isConfirm = false; // Close dialog
                    resolve(confirmed); // Resolve promise with user decision
                };
            });
        },

        async applyToFinalIncrementHandler(){
            try{
                const res = await this.$store.dispatch('put', { url: "/pmrewardsimulationdetailapplytargetincrement/edit/" + this.formData.id, 
                payload: this.formData });
                if (res.status === 200) {
                    await this.loadPmRewardSimulationDetail(); // reload the detail
                    this.detailkey++; //force update
                    await this.modifyCardHandler();
                }
                else
                {
                    this.isErr = true;
                    this.errMsg = "Failed to update final increment amount";
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                }
            }
            catch(err){
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async applyToFinalBonusHandler(){
            try{
                const res = await this.$store.dispatch('put', { url: "/pmrewardsimulationdetailapplytargetbonus/edit/" + this.formData.id, 
                payload: this.formData });
                if (res.status === 200) {
                    await this.loadPmRewardSimulationDetail(); // reload the detail
                    this.detailkey++; //force update
                    await this.modifyCardHandler();
                }
                else
                {
                    this.isErr = true;
                    this.errMsg = "Failed to update final bonus amount";
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                }
            }
            catch(err){
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async detailRowUpdateHandler(){
            await this.loadPmRewardSimulationDetail(); // reload the detail
            this.detailkey++;
            await this.modifyCardHandler();
        }
        
    },
    async mounted() {
        try {
            
            await this.loadPmRewardSimulationHandler();//try to get, to fill in all related form 
            if(!this.isExsiting)//if not exsits, we run create first
            {
                await this.createPmRewardSimulationHandler();//at the same time, this will call to create detail
            }
            else// if exsits, should able to load the detail
            {
                await this.loadPmRewardSimulationDetail();
            }
            await this.loadCurrencyListHandler();
            await this.modifyCardHandler();
      
            this.isLoading = false;

        } catch (error) {

            this.isErr = true;
            this.errMsg = error.errMsg || error || "Error on Mounted";
            this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
        }
    }

}
</script>